export const pages = {
  auth: {
    login: {
      title: 'Eingang'
    },
    confirmation: {
      title: 'Nachbestätigung',
      description:
        'Wir haben Ihnen einen Brief mit einem Code per E -Mail geschickt __var_0__. Das Senden kann bis zu einer Minute dauern'
    },
    verifyEmail: {
      title: 'Passwortänderung'
    },
    reset: {
      title: 'Passwortänderung'
    },
    otp: {
      title: 'Nachbestätigung',
      description:
        'Wir haben Ihnen einen Brief mit einem Code per E -Mail geschickt __var_0__. Das Senden kann bis zu einer Minute dauern'
    },
    register: {
      title: 'Registrierung __var_0__a'
    },
    invite: {
      title: 'Willkommen bei Live Bright Connect',
      description: 'Wählen Sie Ihre Profilversion'
    }
  },
  notification: {
    title: 'Benachrichtigungen',
    notFound: 'Sie haben noch keine Benachrichtigungen.',
    description:
      'Sie können neue Anwendungen von Künstlern im Abschnitt „Künstler“ in Ihrem Profil anzeigen'
  },
  loyalty: {
    inputLabel: 'Ihr Link:',
    registered: 'Eingetragen',
    followed_link: 'Den Link weitergegeben',
    inputDescription:
      'Um den Künstler einzuladen, senden Sie einen Link zur Registrierung.',
    artist: {
      title: 'Einladung zur Website',
      description:
        'Der Künstler, der die Registrierung Ihres Links abgeschlossen hat, gilt als eingeladen.'
    },
    club: {
      title: 'Treueprogramm',
      note: 'Der Künstler, der die Registrierung Ihres Links abgeschlossen hat, gilt als eingeladen.',
      description: 'Holen Sie sich Künstler ohne Auftrag!',
      text: '👯‍♀️ Hattest du ein Casting und der Künstler passte nicht? Schließt jemand den Vertrag ab? Senden Sie ihr Ihren persönlichen Link.',
      content:
        'Wenn die Künstlerin von Ihrem Link registriert ist, zählt sie Sie. 📌 Für jeweils 5 Künstler erhalten Sie 1 Vertrag ohne Provision - für 1 Kalendermonat. Selbst wenn die Künstlerin einen anderen Club auswählt, wird sie in Ihrem Zähler berücksichtigt.‼ ️ Um am Programm teilzunehmen, muss Ihr Club das Profil ausfüllen und in der Suche sichtbar sein, die Plattform teilen und jetzt Vorteile erhalten.'
    }
  },
  language: {
    title: 'Sprachen',
    description: 'Wählen Sie die Sprache der Plattform',
    options: {
      ru: 'Russisch',
      en: 'Englisch',
      uk: 'Ukrainisch',
      it: 'Italienisch',
      de: 'Deutsch',
      tr: 'Türkisch',
      es: 'Spanisch'
    }
  },
  profilePage: {
    techSupport: 'Pflegedienst',
    privacy: 'Bedingungen und Vertraulichkeit',
    artist: {
      work: 'Im Club arbeiten',
      infoEditSection: 'Bearbeitung',
      infoAppSection: 'Anwendung',
      personalInfo: 'Persönliche Informationen',
      portfolio: 'Portfolio',
      invitationAndRequests: 'Anwendungen und Einladungen',
      hideProfile: 'Das Konto verstecken',
      loyaltyLink: 'Einen Freund einladen'
    },
    club: {
      clubInfoSection: 'Clubinformationen',
      artistsSection: 'Künstler',
      artistHiring: 'Eine Reihe von Künstlern',
      loyaltyProgram: 'Treueprogramm',
      editingSection: 'Bearbeitung',
      clubInfo: 'Persönliche Informationen',
      conditions: 'Bedingungen',
      approvedArtists: 'Genehmigte Künstler',
      requestsAndInvitations: 'Anwendungen und Einladungen',
      applicationSection: 'Anwendung'
    }
  },
  portfolioPage: {
    title: 'Portfolio',
    warnNotPublished:
      'Der Lebenslauf wird nicht veröffentlicht. Füllen Sie das Portfolio aus, um einen Lebenslauf zu veröffentlichen.',
    warnfillPortfolio: 'Füllen Sie das Portfolio aus',
    warnf: 'Füllen Sie das Portfolio aus',
    warnFillSection:
      'Füllen Sie diesen Abschnitt aus, um die Chancen der Einladung zu erhöhen.'
  },
  profileInfo: {
    club: {
      title: 'Über'
    },
    artist: {
      title: 'Über'
    }
  },
  clubTerms: {
    title: 'Bedingungen',
    description:
      'Versuchen Sie, alle Schritte vollständig auszufüllen. Die Attraktivität der Anzeige für die Künstler hängt davon ab. Wende um Hilfe, wenn Schwierigkeiten auftreten.',
    progressSteps: {
      schedule: 'Clubarbeitsplan',
      contractTerms:
        'Der Mindestvertrag, der Zeitplan für Künstler, Tickets, Übertragung vom Flughafen',
      payments:
        'Zahlungen: Wette, Garantie, Foul, Poples, Go-Go, Einzahlung, Show, Tee, Verbrauch, verrücktes Menü',
      workConditions:
        'Art der Konsumation. Choreograph. Fotoshootings. Pilons. Menge',
      housing: 'Informationen über Wohnungsbau. Foto.',
      penalties: 'Elfmetermasch',
      photo: 'Foto des Clubs',
      video: 'Clubvideo'
    }
  },
  clubEmployers: {
    title: 'Genehmigte Künstler',
    tabs: {
      pending: 'In Erwartung',
      onContract: 'Auf den Vertrag'
    }
  },
  requestAndInvitation: {
    title: 'Anwendungen und Einladungen'
  },
  onboarding: {
    club: {
      schedule: {
        title: 'Clubstunden',
        popups: {
          title: 'Öffnungszeiten'
        },
        changeAllWorkTimes: 'Alle Stunden der Arbeit ändern'
      },
      contractTerms: {
        title: 'Arbeitsbedingungen im Club',
        form: {
          minimalContractTerm: {
            label: 'Die Mindestvertragszeit',
            unit: 'Wochen'
          },
          artistsSchedule: {
            label: 'Der Zeitplan der Künstler'
          }
        }
      },
      payments: {
        title: 'Zahlungen',
        rateFieldDescription:
          'Wenn Sie eine Wette mit einer Nummer haben, füllen Sie nur eines der Eingangsfelder aus'
      },
      workConditions: {
        title: 'Arbeitsbedingungen im Club',
        form: {
          noExperienceEmployment: 'Beschäftigung von Künstlern ohne Erfahrung',
          additionalInfo: {
            label: 'Zusätzliche Informationen über den Club',
            placeholder:
              'Sie können über Werbeaktionen oder Boni in Ihrem Club oder andere Informationen schreiben, die für Künstler interessant sein werden',
            description: 'Geben Sie mindestens 100 Zeichen ein'
          }
        },
        popups: {
          dressCode: {
            enterDressCodeElement:
              'Geben Sie das Element des Code des Codes ein',
            description:
              'Wählen Sie die Kleiderordnung für Künstler in Ihrem Club aus. Fügen Sie fehlende Positionen hinzu.'
          }
        }
      },
      housing: {
        title: 'Informationen über Wohnungsbau'
      },
      penalties: {
        title: 'Geldstrafen',
        description:
          'Fügen Sie Ihre Position hinzu, wenn Sie sie in der angegebenen Liste nicht gefunden haben'
      },
      photo: {
        title: 'Foto des Clubs',
        description:
          'Laden Sie Fotos des Clubs herunter. Sie können später Änderungen vornehmen',
        options: {
          hallNoGuests: 'Foto einer leeren Halle',
          hallWithGuests: 'Foto der Halle mit Gästen',
          privateRooms: 'Foto von privaten Zimmern',
          scene: 'Foto der Szene'
        }
      },
      video: {
        title: 'Clubvideo',
        description:
          'Laden Sie das Clubvideo herunter. Sie können später Änderungen vornehmen',
        options: {
          ClubTour: 'Video der leeren Halle',
          EventVideo: 'Videohalle mit Gästen',
          WorkingHours: 'Videoszenen'
        }
      }
    },
    artist: {
      work: {
        title: 'Erfahrung in Clubs',
        addWorkPlace: 'Fügen Sie einen Arbeitsplatz hinzu',
        notHaveWorkExperience: 'Ohne Erfahrung weitermachen'
      },
      language: {
        title: 'Sprachen',
        languageProfinience: 'Bowling Fremdsprachen'
      },
      parametres: {
        title: 'Parameter'
      },
      about: {
        title: 'Über dich',
        description:
          'Schreiben Sie über sich selbst, was für den Club interessant sein wird',
        textAreaDescription: 'Geben Sie mindestens 100 Zeichen ein',
        textAreaPlaceholder: 'Eingeben'
      },
      video: {
        title: 'Video',
        videoForHostesVacancy: '2. Laden Sie das Video -Laufwerk herunter',
        videoForGogoVacancy:
          '1. Laden Sie das Video herunter, wie Sie tanzen, um einen Leerstandsstreifen -Tänzer zu tanzen, und gehen Sie'
      },
      photo: {
        title: 'Foto',
        description:
          'Laden Sie Fotos herunter. Fotos sollten ohne Filter und Photoshop sein.',
        FaceNoMakeup: 'Modell ist ein Gesicht ohne Make -up.',
        FaceWithMakeup: 'Gesicht / machen -up.',
        FreePose: 'Fotomodell in einer kostenlosen Pose.',
        FullBodyOnHeels: 'Fotos des Modells in voller Höhe in Absätzen.',
        LingerieOrSwimsuit: 'Fotomodell in einem Badeanzug',
        selectMainPhoto: 'Wählen Sie das Hauptfoto'
      }
    }
  },
  workInteraction: {
    club: {
      artistHaveContract: 'Der Künstler arbeitet bereits im Club',
      incompleted:
        'Um Einladungen zu senden, müssen Sie Ihr Profil zu 100%ausfüllen.'
    },
    artist: {
      weCanRequestLastWorkDate:
        'Fordern Sie Ihr Vertragsende beim Club an.',
      clubSetLastWorkDate:
        'Der Club hat Ihr letztes Arbeitsdatum in diesem Club festgelegt.',
      clubNotHiring:
        'Sie können keine Anfrage senden, da der Club keine Künstlergruppe eröffnet hat.',
      pendingRequest:
        'Sie können nicht innerhalb von 48 Stunden mehr als eine Anfrage senden.',
      haveContract:
        'Sie können keine Anfrage senden, da Sie einen aktuellen Vertrag haben.',
      hidden:
        'Sie können keine Anfrage senden, da Ihr Profil vor der Suche verborgen ist.',
      incompleted:
        'Sie können keine Anfrage senden, da Sie das Profil nicht vollständig ausgefüllt haben.'
    }
  },
  notFoundWorkItem: {
    title: 'Diese Einladung oder Anfrage existiert nicht mehr.',
    description:
      'Es tut uns leid, aber die Seiten existieren nicht. Bitte gehen Sie vagial.'
  },
  notFoundCurrentWork: {
    title: 'Aktiver Vertrag',
    description:
      'Im Moment haben Sie keinen aktiven Vertrag, gehen zur Suchseite und senden einen Antrag an den Club, um einen Vertrag zu starten.'
  },
  clubFullProfile: {
    clubVideo: 'Clubvideo',
    clubPhoto: 'Foto des Clubs',
    clubHousingPhoto: 'Foto des Wohnraums',
    minimalContractDuration: 'Mindestvertrag',
    artistWorkSchedule: 'Arbeitsplan',
    paymentFrequescyMessage:
      'Zahlungen an den Künstler für die Verbraucher - 1 Mal in'
  },
  privacyPolicy: {
    title: 'Benutzervereinbarung und Datenschutzrichtlinie'
  },
  chat: {
    requestSupport: {
      inviteManagerInChat: 'Laden Sie einen Manager ein, sich zu unterhalten',
      managerIsInChat: 'Chat Manager',
      manageRequestPending: 'Der Manager wird bald hinzugefügt'
    },
    admin: {
      assistanceProvided: 'Hilfe wird zur Verfügung gestellt',
      openDirectChat: 'Открыть личный чат',
      openWhatsApp: 'WhatsApp öffnen',
      phoneNumberNotAvailable: 'Telefonnummer nicht verfügbar'
    }
  }
};
